// Дизайн-система Scriptera. Токены (tokens.css), Tailwind-пресет и общие компоненты.
// Компоненты переносятся 1:1 из docs/mockups/* по мере этапов.

export { Generator } from './generator/generator';
export type { GeneratorDict, GeneratorChip } from './generator/generator';
export { DialogReplay } from './generator/dialog-replay';
export type { Msg as GeneratorMsg } from './generator/chat-view';
export { Composer } from './generator/composer';
export type { ComposerDict } from './generator/composer';
// Голосовой ввод отдельно (родной композер чата, Трек 2): натив-микрофон ведёт к ТОМУ ЖЕ
// распознаванию (INVARIANT: логика записи живёт только в use-voice-input).
export { useVoiceInput } from './generator/use-voice-input';
export type { VoiceInput } from './generator/use-voice-input';
export type { ScenarioGraph, ScenarioStep, ScenarioBranch, CatalogParam } from './scenario/graph';
export { ParamsForm, AutoGrowTextarea } from './scenario/params-form';
export type { ParamsFormDict, DynFieldQuery, DynOptionsLoader } from './scenario/params-form';
export type { DataPick, DataPickStep } from './scenario/data-picker';
export { StepOutputPanel } from './scenario/output-panel';
export type { StepOutput, StepOutputDict, StepRunInfo } from './scenario/output-panel';
export type { BinarySample, ShapeField } from './scenario/data-shape';
export { SmartSelect } from './scenario/smart-select';
export { PopSelect, PopMenu, PopMenuLayer, PopPanel } from './scenario/pop-select';
export type { PopSelectOption, PopMenuItem, PopMenuSection } from './scenario/pop-select';
export type { SmartOption } from './scenario/smart-select';
// FORM-ENGINE §5: паспорта моделей Scriptera — слой формы над форматом n8n.
export {
  applyModelPassport,
  foldPassportValues,
  passportModelOptions,
  passportOutputNote,
  passportPriceWords,
  passportValueDrops,
  passportWarnings,
  unfoldPassportValues,
  PASSPORT_MAIN_PARAMS,
  PASSPORT_NODE,
} from './scenario/model-passport';
export type { ModelPassport, ModelPassportVideo } from './scenario/model-passport';
